<template>
  <b-modal ref="approval-owner-modal" hide-footer :titleHtml="modalTitle">
    <b-row>
      <b-col md="6">
        <b-form-group :label="'Người duyệt theo'">
          <b-form-select
            v-model="configDetailModel.ownerType"
            :options="ownerTypeOptions"
            size="sm"
            class="select-style"
            value-field="id"
            text-field="name"
            @change="onChangeOwnerType"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group :disabled="ownerDisabled">
          <label>Người duyệt</label>
          <vue-multi-select
            v-model="configDetailModel.owners"
            :options="ownerOptions"
            placeholder="Chọn người duyệt"
            option-label="name"
          ></vue-multi-select>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="modal-actions">
      <b-button class="save-button" variant="primary" size="sm" @click="onSave"
        >Lưu</b-button
      >
      <b-button
        class="cancel-button"
        variant="secondary"
        size="sm"
        @click="hideModal"
        >Hủy</b-button
      >
    </div>
  </b-modal>
</template>

<script>
import VueMultiSelect from 'vue-simple-multi-select';
import { cloneDeep, makeToastFaile } from '@/utils/common';
import { APPROVAL_CONFIG_OWNER_TYPE } from '@/utils/enum';
import commonMixin from '@/view/mixins/api-common.mixins';
import ApprovalConfigService from '../../services/ApprovalConfigService';

export default {
  name: 'ApprovalOwnerModal',
  components: {
    VueMultiSelect,
  },
  mixins: [commonMixin],
  props: {
    /**
     * Mode of the form (create or update)
     */
    mode: {
      type: String,
      default: 'create',
    },
  },
  data() {
    return {
      modalTitle: '',
      configDetailModel: {
        ownerType: APPROVAL_CONFIG_OWNER_TYPE.POSITION,
      },
      ownerOptions: [],
      ownerDisabled: false,
      configDetail: {},
      employeeOptions: [],
      ownerTypeOptions: [
        {
          id: APPROVAL_CONFIG_OWNER_TYPE.POSITION,
          name: 'Chức vụ',
        },
        {
          id: APPROVAL_CONFIG_OWNER_TYPE.IDENTIFICATION,
          name: 'Đích danh',
        },
        {
          id: APPROVAL_CONFIG_OWNER_TYPE.AUTO_APPROVE,
          name: 'Tự động duyệt',
        },
      ],
      jobTitleOptions: [],
    };
  },
  mounted() {
    this.getJobTitles();
  },
  methods: {
    /**
     * Show the modal with the given config detail
     */
    async showModal(configDetail) {
      this.configDetail = configDetail;
      await this.fetchEmployees();
      this.configDetailModel = cloneDeep(configDetail);
      this.modalTitle = `<div>
              <span class='d-block' style='font-size: 1.1rem'>Người duyệt cho: <a class='text-primary'>#Bước ${configDetail.step || 1}</a></span>
              </div>`;
      this.$refs['approval-owner-modal'].show();
    },

    /**
     * Fetch employees from the API
     */
    async fetchEmployees() {
      try {
        this.employeeOptions = await ApprovalConfigService.fetchEmployees();
        this.onChangeOwnerType();
      } catch (error) {
        console.error('Error fetching employees:', error);
      }
    },

    async getJobTitles() {
      this.jobTitleOptions = await this.fetchJobTitles();
    },
    /**
     * Handle owner type change
     */
    onChangeOwnerType() {
      if (this.configDetailModel.ownerType === 3) {
        this.ownerOptions = [];
        this.configDetailModel.owners = [
          {
            id: -1,
            name: 'Tự động duyệt',
          },
        ];
        this.ownerDisabled = true;
        return;
      }

      if (this.configDetailModel.ownerType === 1) {
        this.ownerOptions = this.jobTitleOptions;
      }

      if (this.configDetailModel.ownerType === 2) {
        this.ownerOptions = this.employeeOptions;
      }

      this.ownerDisabled = false;
      this.configDetailModel.owners = this.configDetail.owners;
    },

    /**
     * Save the config detail
     */
    onSave() {
      if (
        !this.configDetailModel.owners ||
        !this.configDetailModel.owners.length
      ) {
        return makeToastFaile('Vui lòng chọn người duyệt!');
      }

      this.$emit('save', this.configDetailModel);
      this.hideModal();
    },

    /**
     * Hide the modal
     */
    hideModal() {
      this.$refs['approval-owner-modal'].hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.select-style {
  width: 100%;
}

.modal-actions {
  display: flex;
  margin-top: 1rem;

  .save-button {
    font-weight: 600;
    width: 100px;
  }

  .cancel-button {
    margin-left: 10px;
    font-weight: 600;
    width: 70px;
  }
}
</style>
